import { ReactElement } from 'react';
import { Link } from '@mui/material';
import { IAMRole } from '@localstack/types';
import { getSchema } from '@localstack/services';

import { MagicTable } from '../../../magic/MagicTable';

const DEFAULT_PAGE_SIZE = 100;

export interface IAMRolesTableProps {
  roles: IAMRole[];
  loading?: boolean;
  page: number;
  pageSize?: number;
  onPageChange: (page: number) => unknown;
  selectable?: boolean;
  onViewRole?: (group: IAMRole) => unknown;
  onSelect?: (ids: string[]) => unknown;
}

export const IAMRolesTable = ({
  roles,
  loading,
  page,
  pageSize,
  onPageChange,
  selectable,
  onViewRole,
  onSelect,
}: IAMRolesTableProps): ReactElement => (
  <MagicTable
    schema={getSchema('IAM')}
    autoHeight={false}
    entry="Role"
    idAttribute="RoleName"
    rows={roles}
    selectable={selectable}
    onSelect={onSelect}
    order={['RoleId', 'RoleName']}
    loading={loading}
    page={page}
    paginationMode="client"
    pageSize={pageSize ?? DEFAULT_PAGE_SIZE}
    rowsPerPageOptions={[DEFAULT_PAGE_SIZE]}
    rowCount={roles.length}
    onPageChange={onPageChange}
    externalFields={{
      RoleId: (row) => (
        <Link onClick={() => onViewRole && onViewRole(row)} underline="hover">
          {row.RoleId}
        </Link>
      ),
    }}
  />
);
